module.exports = __webpack_public_path__ + "static/img/20180414165927.b0cdd690.jpg";